import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { assignTicketsManuallyAsync, assignTicketFromDatabaseAsync, getAllTicketsAsync, getRelationForTicketsAsync, UnassignTicketsAsync, uploadExcelAsync, sendTicketEmailAsync, sendBulkTicketEmailAsync, uploadTicketDocumentAsync } from './ticketsThunk';
const initialState = {
    status: APIStatus.IDLE,
    searchString: null,
    tickets: null,
    ticket: null,
    ticketrelation: undefined,
    ticketDocument: null
};
export const ticketsSlice = createSlice({
    name: 'tickets',
    initialState,
    reducers: {
        resetTicketsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        resetSearchString(state) {
            state.searchString = null;
        },
        setSearchString(state, action) {
            state.searchString = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // Upload Excel
            .addCase(uploadExcelAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(uploadExcelAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(uploadExcelAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Get All Tickets
            .addCase(getAllTicketsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllTicketsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.tickets = action.payload;
        })
            .addCase(getAllTicketsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Assign Ticket Manually
            .addCase(assignTicketsManuallyAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(assignTicketsManuallyAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.ticket = action.payload;
        })
            .addCase(assignTicketsManuallyAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Assign Ticket From Database
            .addCase(assignTicketFromDatabaseAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(assignTicketFromDatabaseAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.ticket = action.payload;
        })
            .addCase(assignTicketFromDatabaseAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            .addCase(getRelationForTicketsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getRelationForTicketsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.ticketrelation = action.payload;
        })
            .addCase(getRelationForTicketsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Unassign Ticket 
            .addCase(UnassignTicketsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(UnassignTicketsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.ticket = action.payload;
        })
            .addCase(UnassignTicketsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Send Ticket Email 
            .addCase(sendTicketEmailAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(sendTicketEmailAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.ticket = action.payload;
        })
            .addCase(sendTicketEmailAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Send Bulk Ticket Email 
            .addCase(sendBulkTicketEmailAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(sendBulkTicketEmailAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(sendBulkTicketEmailAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
        builder
            // Upload Ticket Document 
            .addCase(uploadTicketDocumentAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(uploadTicketDocumentAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.ticketDocument = action.payload;
        })
            .addCase(uploadTicketDocumentAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
    }
});
export const { resetTicketsApiState, resetSearchString, setSearchString } = ticketsSlice.actions;
export default ticketsSlice.reducer;
